import { useEffect } from "react";

const SITE_ORIGIN = "https://daisydoes.co.uk";

const upsertMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const match = selector.match(/\[(name|property)="([^"]+)"\]/);
    if (match) el.setAttribute(match[1], match[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const absoluteImage = (image) => (image.startsWith("http") ? image : `${SITE_ORIGIN}${image}`);

/**
 * Per-page SEO: updates document.title, meta description, OG, Twitter Card tags
 * and canonical link. Module-level helpers are stable references so the effect
 * dependency array can be kept minimal and correct.
 */
export const useSEO = ({ title, description, path = "/", image = "/og-image.jpg", noIndex = false }) => {
  useEffect(() => {
    if (title) document.title = title;

    const url = `${SITE_ORIGIN}${path}`;
    const ogImage = absoluteImage(image);

    upsertMeta('meta[name="description"]', "content", description);
    upsertMeta('meta[name="robots"]', "content", noIndex ? "noindex, nofollow" : "index, follow, max-image-preview:large");

    upsertMeta('meta[property="og:title"]', "content", title);
    upsertMeta('meta[property="og:description"]', "content", description);
    upsertMeta('meta[property="og:url"]', "content", url);
    upsertMeta('meta[property="og:image"]', "content", ogImage);
    upsertMeta('meta[property="og:type"]', "content", "website");

    upsertMeta('meta[name="twitter:title"]', "content", title);
    upsertMeta('meta[name="twitter:description"]', "content", description);
    upsertMeta('meta[name="twitter:image"]', "content", ogImage);
    upsertMeta('meta[name="twitter:card"]', "content", "summary_large_image");

    upsertLink("canonical", url);
  }, [title, description, path, image, noIndex]);
};

export default useSEO;
